import type { VerticalId } from '@weather-story/vertical-config';
import type { RouteObject } from 'react-router';

interface VerticalRoutes {
  routes: RouteObject[];
  adminRoutes: RouteObject[];
}

/**
 * Get the route definitions for a vertical.
 *
 * Each vertical exports its own routes. Only the active vertical's
 * routes are imported — others are never loaded.
 */
export async function loadVerticalRoutes(id: VerticalId): Promise<VerticalRoutes> {
  switch (id) {
    case 'anomly': {
      const { anomlyRoutes, anomlyAdminRoutes } = await import('./anomly/routes');
      return { routes: anomlyRoutes, adminRoutes: anomlyAdminRoutes };
    }
    case 'histry': {
      const { histryRoutes, histryAdminRoutes } = await import('./histry/routes');
      return { routes: histryRoutes, adminRoutes: histryAdminRoutes };
    }
    case 'weathr':
    default: {
      const { weathrRoutes, weathrAdminRoutes } = await import('./weathr/routes');
      return { routes: weathrRoutes, adminRoutes: weathrAdminRoutes };
    }
  }
}
